<script>
export default {
  name: "navbar",
  data: function() {
    return {};
  },
  methods: {
    toggleNavBar: function() {
      this.$store.commit("toggleNav", !this.isNavExpanded);
    },
    navigateToAccount: function() {
      if (this.activeNav != "settings") {
        this.$router.push("/settings");
      }
    },
    openCorporate: function() {
      window.open("https://www.seabrokers.co.uk/shipping/", "_blank");
    },
    async onLogoutClick() {
      var result = window.confirm("Are you sure you want to log out?");
      if (result) {
        await this.$store.dispatch("logout");
        this.$router.push("/login");
      }
    },
    addMobileNavScrollEvent() {
      var prevScrollpos = window.pageYOffset;
      var self = this;
      window.onscroll = function() {
        if (self.isMobile) {
          var currentScrollPos = window.pageYOffset;
          if (prevScrollpos > currentScrollPos || currentScrollPos < 50) {
            document.getElementById("top-nav-mobile").style.top = "0";
          } else {
            document.getElementById("top-nav-mobile").style.top = "-60px";
          }
          prevScrollpos = currentScrollPos;
        }
      };
    },
    getWrapperClass() {
      var result = "";
      if (this.isNavExpanded) {
        result += "menu-expanded";
      } else {
        result += "menu-collapsed";
      }
      if (this.navbarExpandedOverlay) {
        result += "expanded-overlay";
      }
      return result;
    },
  },
  created: function() {},
  computed: {
    userRole: function() {
      return this.$store.state.role;
    },
    isOwner: function() {
      return this.userRole == "OWN";
    },
    userName: function() {
      return this.$store.state.name;
    },
    isNavExpanded: function() {
      return this.$store.state.isNavExpanded;
    },
    isMobile: function() {
      return this.$store.state.isMobile;
    },
    activeNav: function() {
      return this.$store.state.activeNav;
    },
    currentEnvironment: function() {
      return process.env.VUE_APP_ENVIRONMENT;
    },
    notProd: function() {
      return this.currentEnvironment != "production";
    },
    isLocal: function() {
      return this.currentEnvironment == "local";
    },
  },
  mounted() {
    this.addMobileNavScrollEvent();
  },
};
</script>
<template>
  <div class="nav-wrapper" :class="getWrapperClass()" v-if="!isMobile" style="text-align:center;">
    <div class="collapse-button-wrapper hoverable" v-on:click="toggleNavBar">
      <i :class="[isNavExpanded ? 'fa-chevron-circle-left' : 'fa-chevron-circle-right']" class="fas"></i>
    </div>
    <router-link to="/dashboard">
      <img class="main-logo" style="margin-top:2rem;" src="@/assets/images/logo-07.png" />
      <img class="main-logo-text" :class="[isNavExpanded ? 'menu-expanded-text' : 'menu-collapsed-text']" src="@/assets/images/logo-06.png" />
    </router-link>
    <div v-if="isNavExpanded" class="user-details">
      <i v-on:click="navigateToAccount()"
        >Logged in as <span>{{ userName }} <span v-if="userRole == 'ADM'">(Admin)</span></span></i
      >
    </div>

    <ul class="navbar-nav ml-autod" style>
      <li class="nav-item" id="dashboard" v-bind:class="[activeNav == 'dashboard' ? 'active' : '']">
        <a class="nav-link"
          ><router-link to="/dashboard"><i title="Dashboard" class="fas fa-home icon-left"></i><span class="nav-text" v-if="isNavExpanded">Home</span></router-link></a
        >
      </li>
      <li class="nav-item" id="settings" v-bind:class="[activeNav == 'settings' ? 'active' : '']">
        <a class="nav-link"
          ><router-link to="/settings"><i title="Settings" class="fas fa-cog icon-left"></i><span class="nav-text" v-if="isNavExpanded">Settings</span></router-link></a
        >
      </li>
      <li class="nav-item" id="logout" v-bind:class="[activeNav == 'logout' ? 'active' : '']" v-on:click="onLogoutClick()">
        <a class="nav-link"
          ><a><i title="Settings" class="fas fa-sign-out-alt icon-left"></i><span class="nav-text" v-if="isNavExpanded">Logout</span></a></a
        >
      </li>
    </ul>
    <div class="group-logo-wrapper" title="Courtesy of Seabrokers - The shipbroker with a difference" v-on:click="openCorporate()">
      <img v-if="isNavExpanded" src="@/assets/images/seabrokersGroup-04.png" />
      <img v-else src="@/assets/images/seabrokersLogoCircle.png" />
    </div>
    <!--     <div v-if="notProd && !isLocal && isNavExpanded" class="not-prod">
      <b style="font-size:18px">This is not a production instance</b><br />
      This is the <b>{{ currentEnvironment }}</b> instance of SeaBid
    </div> -->
  </div>
  <div v-else class="nav-bar-mobile">
    <div class="navbar fixed-top " id="top-nav-mobile">
      <img class="main-logo" src="@/assets/images/logo-06.png" />
    </div>
    <ul class="navbar fixed-bottom nav-fill">
      <li class="nav-item" id="dashboard" v-bind:class="[activeNav == 'dashboard' ? 'active' : '']">
        <a class="nav-link"
          ><router-link to="/dashboard" style="position:relative"><i title="Dashboard" class="fas fa-home mobile-nav-icon"></i><span class="mobile-nav-text">Home</span></router-link></a
        >
      </li>
      <li class="nav-item" id="settings" v-bind:class="[activeNav == 'settings' ? 'active' : '']">
        <a class="nav-link"
          ><router-link to="/settings" style="position:relative"><i title="Settings" class="fas fa-cog mobile-nav-icon"></i><span class="mobile-nav-text">Settings</span></router-link></a
        >
      </li>
      <li class="nav-item" id="logout" v-bind:class="[activeNav == 'logout' ? 'active' : '']">
        <a class="nav-link"
          ><a v-on:click="onLogoutClick()" style="position:relative"><i title="Logout" class="fas fa-sign-out-alt mobile-nav-icon"></i><span class="mobile-nav-text">Logout</span></a></a
        >
      </li>
    </ul>
  </div>
</template>
<style scoped>
.collapse-button-wrapper {
  cursor: pointer;
  z-index: 999;
}
.collapse-button-wrapper > i {
  color: #00b4e3;
  font-size: 24px;
  margin-left: -1px;
  margin-top: -1px;
}
.collapse-button-wrapper {
  position: absolute;
  right: -12px;
  top: 50px;
  background-color: white;
  border-radius: 99999999px;
  height: 22px;
  width: 22px;
}
.nav-wrapper {
  height: 100%; /* 100% Full-height */
  position: fixed; /* Stay in place */
  z-index: 10; /* Stay on top */
  top: 0; /* Stay at the top */
  left: 0;
  background: white;
  overflow-x: hidden; /* Disable horizontal scroll */
  padding: 0px 0px 15px 0;
  -webkit-box-shadow: 7px 3px 9px -5px rgba(0, 0, 0, 0.57);
  box-shadow: 7px 3px 9px -5px rgba(0, 0, 0, 0.57);
  overflow: visible;
}

.menu-expanded {
  width: 250px;
}
.menu-collapsed {
  width: 75px;
}
.active a {
  color: #004996 !important;
}
.nav-item.active {
  background-color: #dae0e5;
}
.nav-item:hover {
  background-color: #f0f2f3;
}
.nav-item.active > a i,
.nav-item:hover > a i {
  cursor: pointer;
  transform: scale(1.6);
}
.nav-item:hover:not(.active) > a i,
.nav-item:hover:not(.active) .nav-link > a {
  color: #608ebd !important;
}

.nav-link {
  margin-left: 15px;
  padding: 0px;
}
.nav-link > a,
.nav-link > i {
  width: 100%;
  height: 100%;
  display: block;
  padding: 0.5rem 1rem 0.5rem 0;
  color: #608ebd;
}
a:hover {
  text-decoration: none;
}
.fixed-bottom {
  margin: 0px;
  padding: 0px;
  background-color: #f8f9fa;
  height: 60px;
  border-top: 1px solid #d2d2d2;
  list-style: none;
}
.fixed-bottom a {
  height: 60px;
  padding: 0px;
}
.fixed-bottom a {
  line-height: 60px;
}

.fixed-bottom .nav-link {
  margin: 0px;
}
.not-prod {
  text-align: center;
  position: absolute;
  bottom: 0px;
}
.main-logo,
.nav-wrapper,
.main-logo-text {
  transition: width 0.2s, height 0.2s;
}
.menu-collapsed .main-logo {
  width: 50px;
}
.menu-expanded .main-logo {
  width: 100px;
}
.menu-expanded-text {
  width: 175px;
}
.menu-collapsed-text {
  width: 0px;
}

.menu-expanded ul {
  text-align: left;
}
.navbar-nav {
  transition: height 0.2s;
  position: absolute;
  width: 100%;
}
.menu-expanded .navbar-nav {
  top: 220px;
}
.menu-collapsed .navbar-nav {
  top: 120px;
}
.nav-text {
  margin-left: 25px;
}
.user-details {
  color: #004996;
  font-size: 12px;
}
.user-details:hover {
  text-decoration: underline;
  cursor: pointer;
}
.group-logo-wrapper {
  text-align: center;
  width: 100%;
  position: absolute;
  bottom: 50px;
}
.group-logo-wrapper img {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}
.mobile-nav-text {
  font-size: 10px;
  position: absolute;
  width: 100%;
  bottom: -15px;
  left: 0px;
}
.mobile-nav-icon {
  width: 100%;
  position: absolute;
  top: 15px;
  left: 0px;
}
.navbar.fixed-top {
  width: 100%;
  z-index: 11; /* Stay on top */
  height: 60px;
  z-index: 11;
  position: fixed;
  background-color: #f8f9fa; /* Black*/
  top: 0;
  transition: top 0.5s;
  border-bottom: 1px solid #d2d2d2;
  text-align: center;
}
.fixed-top > img {
  margin: auto;
  margin-top: 0px;
  height: 40px;
}
</style>
